export const removeYoutubeFrameConsent = () => {
    document.querySelectorAll('iframe[data-youtube-src]').forEach(el => {
        const src = el.getAttribute('data-youtube-src');
        el.setAttribute('src', src);
        el.removeAttribute('data-youtube-src');
    });
}